import { request } from '@/api/httpClient'

export async function reportGrabJobSuperUser(contractId, jobId) {
  return request({
    method: 'export/GrabJobSuperUser',
    payload: {
      ContractId: contractId,
      JobKey: jobId
    }
  })
}

export async function reportVpressRegister({ jwt_token, prefix }) {
  return request({
    method: { endpoint: import.meta.env.VITE_APP_STORE_PREFIX, method: 'api/vpress-register' },
    payload: {
      jwt_token,
      prefix
    }
  })
}

export async function reportDisplayStream(url, options = {}) {
  const response = await request({
    method: url
  })
  return window.URL.createObjectURL(new Blob([response], options))
}
